export { default } from './BottomNavigationAction';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/BottomNavigationAction/index.js
// module id = 307
// module chunks = 0